/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2534
 */

module.exports = function (e) {
  return function (t) {
    return null == t ? undefined : t[e]
  }
}
